import type { IconSvgObject } from './types';

const Playlist03Icon: IconSvgObject = [
  ["path", { d: "M2 3L20 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 10L14 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 17H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18 18V9C18 9 19 12.5 22 12.5M18 18C18 19.6569 16.6569 21 15 21C13.3431 21 12 19.6569 12 18C12 16.3431 13.3431 15 15 15C16.6569 15 18 16.3431 18 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Playlist03Icon;
